<template>
  <div class="video-container" :class="{'full-screen':isFullScreen}">
    <div class="video-wrap j_video_wrap" :id="videoId" v-if="wxAndroidFlag">
      <!-- <video class="j_video video"
        :class="{'cover-fit': videoFormat === 'COVER'}"
        :style="{'border-radius': `${radius}`}"
        loop="loop"
        autoplay
        x-webkit-airplay="true"
        x5-playsinline="true"
        webkit-playsinline="true"
        playsinline="true"
        muted="muted"
        @click="toggleContr"
      ></video> -->
      <video 
        v-if="muted"
        class="j_video video"
        :class="{'cover-fit': videoFormat === 'COVER'}"
        :style="{'border-radius': `${radius}`}"
        loop="loop"
        autoplay
        x5-video-player-type="h5"
        x-webkit-airplay="true"
        x5-playsinline="true"
        webkit-playsinline="true"
        playsinline="true"
        muted="muted"
        @click="toggleContr"
      ></video>
      <video 
        v-else
        class="j_video video"
        :class="{'cover-fit': videoFormat === 'COVER'}"
        :style="{'border-radius': `${radius}`}"
        loop="loop"
        autoplay
        x5-video-player-type="h5"
        x-webkit-airplay="true"
        x5-playsinline="true"
        webkit-playsinline="true"
        playsinline="true"
        @click="toggleContr"
      ></video>
    </div>
    <div class="video-wrap j_video_wrap" :id="videoId" v-else>
      <video 
        v-if="loop && muted"
        class="j_video video"
        :class="{'cover-fit': videoFormat === 'COVER'}"
        :style="{'border-radius': `${radius}`}"
        loop="loop"
        autoplay
        x5-video-player-type="h5"
        x-webkit-airplay="true"
        x5-playsinline="true"
        webkit-playsinline="true"
        playsinline="true"
        muted="muted"
        @click="toggleContr"
      ></video>
      <video 
        v-else-if="loop && !muted"
        class="j_video video"
        :class="{'cover-fit': videoFormat === 'COVER'}"
        :style="{'border-radius': `${radius}`}"
        loop="loop"
        autoplay
        x5-video-player-type="h5"
        x-webkit-airplay="true"
        x5-playsinline="true"
        webkit-playsinline="true"
        playsinline="true"
        @click="toggleContr"
      ></video>
      <video 
        v-else-if="!loop && muted"
        class="j_video video"
        :class="{'cover-fit': videoFormat === 'COVER'}"
        :style="{'border-radius': `${radius}`}"
        autoplay
        x5-video-player-type="h5"
        x-webkit-airplay="true"
        x5-playsinline="true"
        webkit-playsinline="true"
        playsinline="true"
        muted="muted"
        @click="toggleContr"
      ></video>
      <video 
        v-else-if="!loop && !muted"
        class="j_video video"
        :class="{'cover-fit': videoFormat === 'COVER'}"
        :style="{'border-radius': `${radius}`}"
        autoplay
        x5-video-player-type="h5"
        x-webkit-airplay="true"
        x5-playsinline="true"
        webkit-playsinline="true"
        playsinline="true"
        @click="toggleContr"
      ></video>
    </div>

    <div class="loading j_loading">
      <div class="img-wrap j_loading_img"><span></span></div>
    </div>
    <div class="poster j_poster">
      <img :src="poster" class="poster-img j_poster_img"
        @load="posterLoaded"
      />
      <div class="play-mask">
        <img src="./assets/play.png" class="play-icon j_play_btn"
          @click="onPlay"
        />
      </div>
    </div>

    <controller
      v-if="showControls"
      :class="{'c-hidden': !isShowContr}"
      :updateTime="updateTime"
      :duration="duration"
      :width="w"
      :wrap="wrap"
      :mutedD="muted"
      :controlsFlag="controls"
      :videoId="videoId"
      :videoIndex="videoIndex"
      :totalVideo="totalVideo"
      :autoplay="autoplay"
      :loop="loop"
      @play="cPlay"
      @pause="cPause"
      @jump="cJump"
      @full="cFull"
      @exitfull="cExitFull"
      @mutedA="cMuted"
      @voice="cVoice"
      @control-action="controlAction"
    />
  </div>
</template>

<script>
import browser from '@beastshop/browser'

import BDialog from '@/components/dialog'
import controller from './components/controller'

const winWidth = window.innerWidth

export default {
  components: {
    BDialog,
    controller
  },

  props: {
    wrap: {
      default: ''
    },
    videoId: {
      default: ''
    },
    videoIndex: {
      default: 0
    },
    totalVideo: {
      default: 0
    },
    width: {
      default: 'auto',
    },
    height: {
      default: 'auto'
    },
    controls: {
      default: true
    },
    poster: {
      default: './assets/poster.jpeg'
    },
    source: String,
    autoplay: {
      default: false
    },
    videoFormat: {
      default: ''
    },
    muted: {
      default: 'muted'
    },
    radius: {
      default: '0'
    },
    multiVideo: {
      default: false
    },
    videoPopData: {
      default: null
    },
    playVideo: {
      default: false
    }
  },

  data () {
    return {
      w: 0,
      h: 0,
      // showControls: false,
      showControls: true,//视频controls一直展示，controls字段用来控制进度条是否展示
      container: null,
      added: false,
      video: null,
      videoPop: null,
      video_wrap: null,
      poster_dom: null,
      loading: null,
      loading_dom: null,
      updateTime: 0,
      duration: 0,
      showLoading: false,
      isShowContr: false,
      isFullScreen: false,
      loop: (this.autoplay && !this.controls)?true:false,
      wxAndroidFlag: browser.weixin() && browser.android(),
      // wxAndroidFlag: true
    }
  },

  // watch: {
  //   videoIndex: function(){
  //     console.log(this.videoId, this.totalVideo, this.videoIndex, '$$$$$$$$$$$$$$$$')
  //     for(var i = 0; i<this.totalVideo; i++) {
  //       if(this.videoId) {
  //         this.pause()
  //       }
  //     }
  //   }
  // },

  mounted () {
    const wrap = document.querySelector(`.${this.wrap}`)
    // console.log(wrap, 'wrap')
    this.container = wrap.querySelector('.video-container')
    this.video = this.container.querySelector('.j_video')
    // this.videoPop = this.container.querySelector('.j_video_pop')
    this.video_wrap = this.container.querySelector('.j_video_wrap')
    this.poster_dom = this.container.querySelector('.poster')
    this.loading_dom = this.container.querySelector('.j_loading')
    this.loading = this.container.querySelector('.j_loading_img')

    this.container.style.height = this.height + 'px'
    this.w = this.container.clientWidth || `${this.width}px`
    this.h = this.height

    //默认都有自定义controls  通过controlsFlag控制是否展示播放暂停 进度调节等按钮
    // if (this.controls) {
    //   this.showControls = true
    // }
    if(this.wxAndroidFlag) {
      // this.video.muted = false
      this.showControls = false
    }

    if ((this.autoplay && browser.app()) || this.playVideo) {
      this.onPlay()
    }
    // if ((this.autoplay && browser.app()) || (this.autoplay && this.muted) || this.playVideo) {
    //   this.onPlay()//app里面可以自动播放  非app但是静音模式可以自动播放 
    // }

    if(browser.app() && browser.android()) {
      if(this.muted) {
        this.video.muted = true
      }
    }
  },

  methods: {
    onPlay () {
      if(this.wxAndroidFlag && this.multiVideo) {//安卓的微信环境且是多视频 触发浮层视频
        this.$emit('video-pop', this.videoPopData)
      } else {
        if (!this.added) {
          this._showLoading()
          this._addVideo()
        } else {
          this.play()
        }
      }
    },

    play (time = 0) {
      this.video.currentTime = time
      this.poster_dom.style.display = 'none'
      this.video.play()
    },

    pause() {
      this.video.pause()
      // if (this.controls) {
      //   this.controls.set('pause')
      // }
    },

    cPlay () {
      this.play(this.video.currentTime)
      this.isShowContr = false
    },

    cPause () {
      // console.log(this.video.paused, '###########')
      if(this.videoId) {
        !this.video.paused && this.pause()
      } else {
        this.pause()
      }
    },

    cJump (time) {
      this.video.currentTime = time
    },

    cFull () {
      if (browser.ios()) {
        this.isFullScreen = true
      }
      else {
        this.controls && (this.showControls = false)
        this.video.requestFullScreen && this.video.requestFullScreen()
        this.video.webkitRequestFullScreen && this.video.webkitRequestFullScreen()
      }
    },

    cExitFull () {
      if (browser.ios()) {
        this.isFullScreen = false
      }
    },

    cMuted () {
      this.video.muted = true
    },

    cVoice() {
      this.video.muted = false
    },

    posterLoaded (e) {
      const posterImg = e.currentTarget

      this.fit(posterImg)
      posterImg.style.pointerEvents = 'all'
    },

    fit (el) {
      this._scale(el)

      el.style.visibility = 'visible'
    },

    toggleContr () {
      if (document.webkitIsFullScreen) {
        return
      }
      // this.controls && (this.isShowContr = true)
      this.isShowContr = true
    },

    controlAction () {
      if (document.webkitIsFullScreen) {
        return
      }
      this.isShowContr = !this.isShowContr
    },

    _scale(el) {
      this.w = parseInt(this.w)
      this.h = parseInt(this.h)

      if (this.w && !this.h) {
        el.style.width = '100%'
        this.container.style.height = el.clientHeight + 'px'
        this.h = el.clientHeight + 'px'
      // this.controls && this.controls.setMask(this.height - (Math.round(16 * winWidth / 375) + Math.round(26 * winWidth / 375)))
        return
      }

      if (!this.w && this.h) {
        el.style.height = this.h + 'px'
        el.style.position =  'absolute'
        el.style.webkitTransform = 'translateX(-50%)'
        el.style.transform = 'translateX(-50%)'
        el.style.left = '50%'
        el.style.top = 0

        this.container.style.width = el.clientWidth + 'px'
        this.w = el.clientWidth + 'px'
        // this.controls && this.controls.setMask(this.h - (Math.round(16 * winWidth / 375) + Math.round(26 * winWidth / 375)))
        return
      }

      if (this.w && this.h) {
        let containerScale = this.w / this.h
        let elScale = el.clientWidth / el.clientHeight

        el.style.position = 'absolute'

        if (containerScale > elScale) {
          el.style.height = this.h + 'px'
          el.style.webkitTransform = 'translateX(-50%)'
          el.style.transform = 'translateX(-50%)'
          el.style.left = '50%'
          el.style.top = 0

        } else {
          el.style.width = this.w+2 + 'px'
          el.style.height = '100%'
          // el.style.webkitTransform = 'translateY(-50%)'
          // el.style.transform = 'translateY(-50%)'
          // el.style.top = '50%'
          el.style.transform = 'translateY(0)'
          el.style.top = '-1px' 
          el.style.left = '-1px'
        }
        // this.controls && this.controls.setMask(this.h - (Math.round(16 * winWidth / 375) + Math.round(26 * winWidth / 375)))
        return
      }
      // this.controls && this.controls.setMask(this.h - (Math.round(16 * winWidth / 375) + Math.round(26 * winWidth / 375)))
    },

    _addVideo() {
      // this.video.controls = false
      this.added = true

      this.video.on = (event, callback) => {
        this.video.addEventListener(event, callback)
        return this.video
      }

      this.video.removeAttribute('controls')
      //fuck ios10, onresize only works in ios10
      this.video.onresize = (e) => {
        if (e.srcElement === window) {
          this.video.removeAttribute('controls')
        }
      }

      this.video
        .on('play', () => {
          // this.controls && this.controls.set('play')
          this.$emit('play')
        })
        .on('pause', () => {
          // this.controls && this.controls.set('pause')
          this.$emit('pause')
        })
        .on('waiting', () => {
          this._showLoading()
        })
        .on('canplay', () => {
          this._hideLoading()
        })
        .on('loadedmetadata', () => {
          this.fit(this.video, this.video_wrap)
          this.controls && (this.duration = this.video.duration)
        })
        .on('loadeddata', () => {
          this.play()
        })
        .on('timeupdate', () => {
          this.updateTime = this.video.currentTime + '-' + this.video.duration
          this.$emit('playing', this.video.currentTime)
        })
        .on('ended', () => {
          this.$emit('ended')
          if (this.controls) {
            this.isShowContr = false
            this.updateTime = '0-' + this.video.duration
          }
          this.poster_dom.style.display = ''
        })
        .on('error', (e) => {
          console.log('error', e)
          this.$emit('error', e)
        })
        .on('abort', (e) => {
          console.log('abort', e)
          this.$emit('abort', e)
        })

      this.video.src = this.source
      this.play()
    },

    _showLoading() {
      // this.showControls = false
      this.showLoading = true
      this.loading_dom.style.display = 'block'
      this.loading.style.display = 'block'
    },

    _hideLoading() {
      this.showLoading = false
      this.loading_dom.style.display = 'none'
    },

    resume() {
      this.video.currentTime = 0
      this.video.pause()
      this.poster_dom.style.display = 'block'
      this.$emit('resume')
    },

    isPaused() {
      return this.video.paused
    },
  }
}
</script>

<style lang="stylus">
@import "./index.styl"
</style>



// WEBPACK FOOTER //
// index.vue?0852db79